import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { AcceptanceDocument } from '@shared/models';

@Component({
  selector: 'app-document-file-preview-modal',
  templateUrl: './document-file-preview-modal.component.html',
  styleUrls: ['./document-file-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgxExtendedPdfViewerModule, RktIconComponent, RktButtonDirective],
})
export class DocumentFilePreviewModalComponent {
  document!: AcceptanceDocument;

  documentPagesCount?: number;

  // pdf.js can report a page before the page count arrives, so the last reported page is re-checked once the count is known
  private currentPage?: number;

  isScrolledToTheEnd = false;

  showClose? = false;

  showAccept? = false;

  constructor(public activeModal: ActiveModal) {}

  modalInitData(document: AcceptanceDocument, showClose: boolean, showAccept: boolean) {
    this.showAccept = showAccept;
    this.showClose = showClose;
    this.document = document;
  }

  onPageChange(page: number | undefined): void {
    this.currentPage = page;
    this.markReadOnLastPage();
  }

  onPagesLoaded({ pagesCount }: { pagesCount: number }): void {
    this.documentPagesCount = pagesCount;
    this.markReadOnLastPage();
  }

  private markReadOnLastPage = (): void => {
    if (this.currentPage !== undefined && this.currentPage === this.documentPagesCount) {
      this.isScrolledToTheEnd = true;
    }
  };
}
